import { connect } from 'react-redux';

import { getOrganizationMembersList } from '../Projects/projectsActions';
// Component
import Offices from './Offices';
import {
  clearOfficeCreatedUpdated,
  deleteOffice,
  getOfficesList,
  setOfficeDetails,
} from './officesActions';

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersList: state.project.orgMembersList,
  isLoading: state.office.isLoading,
  officesList: state.office.officesList,
  officeDetails: state.office.officeDetails,
  totalOfficesCount: state.office.totalOfficesCount,
  pageSize: state.office.pageSize,
  reloadOfficeList: state.office.reloadOfficeList,
  filters: state.filterReducer.filters,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
  getOfficesList: params => dispatch(getOfficesList(params)),
  setOfficeDetails: params => dispatch(setOfficeDetails(params)),
  clearOfficeCreatedUpdated: () => dispatch(clearOfficeCreatedUpdated()),
  deleteOffice: params => dispatch(deleteOffice(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(Offices);
